import { PickupParticipantDetailPage } from "components/shared/pickupParticipants";
import { InformationSection } from "../../components/DetailForm/InformationSection";
import { PickupInformationSection } from "../../components/DetailForm/PickupInformation";
import { RegistrationInformationSection } from "../../components/DetailForm/RegistrationSection";

const WPSCheckinAttractionParticipantsDetailPage = () => (
  <PickupParticipantDetailPage
    kind="attraction"
    variant="wps"
    sections={{
      InformationSection,
      RegistrationInformationSection,
      PickupInformationSection,
    }}
  />
);

export default WPSCheckinAttractionParticipantsDetailPage;
